export default class EzPopunder {
  constructor() {
    this.isSP2 = false;
    this.hasOpenedPuWindow = false;
  }

  open(url) {
    this.url = url;

    const puWidth = window.innerWidth - 200;
    const puHeight = window.innerHeight - 50;

    let puOptions = 'toolbar=0,statusbar=1,resizable=1,scrollbars=0,menubar=0,location=1,directories=0';

    if (navigator.userAgent.indexOf('Chrome') !== -1) {
      puOptions = 'scrollbar=yes';
    }

    const puWindow = window.open('about:blank', '', `${puOptions},height=${puHeight},width=${puWidth}`);

    if (navigator.userAgent.indexOf('rv:2.') !== -1) {
      puWindow.puPop = function (c) {
        if (navigator.userAgent.indexOf('rv:2.') !== -1) {
          this.window.open('about:blank').close();
        }
        this.document.location.href = c;
      };
      puWindow.puPop(url);
    } else {
      puWindow.document.location.assign(url);
    }

    setTimeout(window.focus, 200);
    window.focus();

    if (puWindow) {
      puWindow.window.open('about:blank').close();
      puWindow.moveTo(window.screenX + 2, window.screenY + 2);
      puWindow.blur();
      self.focus(); /* eslint-disable-line no-restricted-globals */
    } else {
      if (window.SymRealWinOpen) {
        window.open = window.SymRealWinOpen;
      }
      if (window.NS_ActualOpen) {
        window.open = window.NS_ActualOpen;
      }

      this.isSP2 = (navigator.userAgent.indexOf('SV1') !== -1);

      if (!this.isSP2) {
        this.doPu();
      } else {
        if (window.Event) {
          document.captureEvents(Event.CLICK);
        }
        document.onclick = this.doClickedPu;
      }

      self.focus(); /* eslint-disable-line no-restricted-globals */
      this.doClickedPu();
    }
  }

  doPu() {
    let donePu = null;

    if (!this.hasOpenedPuWindow) {
      donePu = window.open(this.url, '', 'toolbar=1,location=1,directories=0,status=1,menubar=1,scrollbars=1,resizable=1');

      if (donePu) {
        this.hasOpenedPuWindow = true;
        self.focus(); /* eslint-disable-line no-restricted-globals */
      }
    }
  }

  doClickedPu() {
    let donePu = null;

    if (!this.hasOpenedPuWindow) {
      if (!this.isSP2) {
        donePu = window.open(this.url, '', 'toolbar=1,location=1,directories=0,status=1,menubar=1,scrollbars=1,resizable=1');
        self.focus(); /* eslint-disable-line no-restricted-globals */

        if (donePu) {
          this.hasOpenedPuWindow = true;
        }
      }
    }

    if (!this.hasOpenedPuWindow) {
      if (window.Event) {
        document.captureEvents(Event.CLICK);
      }

      document.onclick = this.doPu;
      self.focus(); /* eslint-disable-line no-restricted-globals */
    }
  }
}
